import {Request} from './Request';

/**
 *
 */
export class SetChargingProfileRequest implements Request {
    chargePointSelectList: string[];
    private connectorId: number;
    private chargingProfileId: number;

    constructor(chargePointSelectList: string[], connectorId?: number, chargingProfileId?: number) {
        this.chargePointSelectList = chargePointSelectList;
        this.connectorId = connectorId;
        this.chargingProfileId = chargingProfileId;
    }

    public toString = (): string => {
        return `SetChargingProfileRequest (chargePointSelectList: ${this.chargePointSelectList},
        connectorId: ${this.connectorId}, chargingProfileId: ${this.chargingProfileId})`;
    }

    get connector_d(): number {
        return this.connectorId;
    }

    set connector_d(value: number) {
        this.connectorId = value;
    }

    get charging_profile_id(): number {
        return this.chargingProfileId;
    }

    set charging_profile_id(value: number) {
        this.chargingProfileId = value;
    }
}
